const endpoints = {
  listStrategy: (): string => `strategy`,
  createStrategy: (): string => `strategy`,
  updateStrategy: (id: string): string => `strategy/${id}`,
  loadStrategy: (id: string): string => `strategy/${id}`,
  activeStrategy: (id: string): string => `strategy/${id}`,
};

export default endpoints;
